var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutMinimal',[_c('div',{attrs:{"id":"casting"}},[_c('section',{staticClass:"main"},[_c('div',{staticClass:"casting-box"},[_c('div',{staticClass:"form"},[_c('h1',{staticClass:"title"},[_vm._v("\n              "+_vm._s(_vm.$t('casting.title'))+"\n            ")]),_c('CastingForm')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }